import { render, staticRenderFns } from "./Sheets.vue?vue&type=template&id=06abba1c&scoped=true"
import script from "./Sheets.vue?vue&type=script&lang=ts"
export * from "./Sheets.vue?vue&type=script&lang=ts"
import style0 from "./Sheets.vue?vue&type=style&index=0&id=06abba1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06abba1c",
  null
  
)

export default component.exports